export const avatarName = {
  fontWeight: 600,
  fontSize: ".924rem",
  lineHeight: "1.563rem",
};

export const avatarInfo = {
  fontWeight: 600,
  fontSize: ".924rem",
  lineHeight: "1.563rem",
};

export const testimonial = {
  lineHeight: "1.625rem",
  marginBottom: "1.25rem",
  fontWeight: 500,
  fontStyle: "italic",
};

export const cardsFeatureWrapper = { padding: "6.25rem 7rem" };
